<template>
  <div class="">
    <!-- banner图 -->
    <banner></banner>
    <!-- 菜单按钮 -->
    <div class="list">
      <router-link to="" @click.native="link(item.YEWUID,item.TYPE,item.NAME)" :key="item.ORDERNUM" v-for="item in ywlist">
        <img :src="images[item.ORDERNUM-1]" alt="">
        <p>{{item.NAME}}</p>
      </router-link>
      <!-- <router-link to="/">
        <img src="../../static/1.png" alt="">
        <p>公司变更</p>
      </router-link> -->
      <!-- <router-link to="/">
        <img src="../assets/images/yw_icon3.png" alt="">
        <p>公司变更</p>
      </router-link>
      <router-link to="/">
        <img src="../assets/images/yw_icon1.png" alt="">
        <p>公司变更</p>
      </router-link>
      <router-link to="/">
        <img src="../assets/images/yw_icon2.png" alt="">
        <p>公司变更</p>
      </router-link>
      <router-link list-icon to="/">
        <img src="../assets/images/yw_icon3.png" alt="">
        <p>公司变更</p>
      </router-link>
      <router-link to="/">
        <img src="../assets/images/yw_icon2.png" alt="">
        <p>公司变更</p>
      </router-link>
      <router-link list-icon to="/">
        <img src="../assets/images/yw_icon3.png" alt="">
        <p>更多</p>
      </router-link> -->
    </div>
    <div class="line"></div>
    <!-- 通知通告 -->
    <div class="newslist">
      <div class="title">
        <p>通知通告</p>
        <!-- <router-link to="">查看更多</router-link> -->
      </div>
      <div class="news">
        <router-link :to="{path:'/Newsinfo',query:{newsid:item.NEWS_ID}}" :key="item.NEWS_ID" v-for="item in newslist">
          <p class="van-ellipsis">{{item.TITLE}}</p>
          <p>{{str(item.RECORDTIME)}}</p>
        </router-link>
        <!-- <router-link to="">
          <p>2021年预约办办理事项要求</p>
          <p>2021.01.09</p>
        </router-link> -->
      </div>
    </div>
    <!-- 视频 -->
    <div class="line"></div>
    <div class="newslist" style="padding-bottom: 1.2rem;">
      <div class="title">
        <p>风貌展示</p>
        <!-- <router-link to="">查看更多</router-link> -->
      </div>
      <div class="news">
        <van-swipe :loop="false" :width="250" class="video">
          <van-swipe-item>
             <!-- <img @click="videoplay()" src="../assets/images/play.png" alt=""> -->
            <video id="vd0" src="" poster="../assets/images/vimg3.jpg"></video>

          </van-swipe-item>
          <van-swipe-item>
            <video class="1" src="" poster="../assets/images/vimg4.jpg"></video>
            <!-- <img src="../assets/images/play.png" alt=""> -->
          </van-swipe-item>
        </van-swipe>

      </div>
    </div>
    <!-- 底部 -->
    <tabbar></tabbar>

  </div>
</template>
<script>
  import {Toast,Dialog} from 'vant'
  // import tabber from "./components/tabbar"
  export default {
    data() {
      return {
        newslist:[],
        openid:"",
        SMstatus:"",
        ywlist:[],
        images:[
          require("../assets/images/1.png"),
          require("../assets/images/2.png"),
          require("../assets/images/3.png"),
          require("../assets/images/4.png")
        ]
      };
    },
    created:function(){
      //localStorage.setItem("openid","oLtkvuNahau0w0e4pyAtRmHjVFmM")
      //this.$store.state.openId=localStorage.getItem("openid")
      //this.common.getOpenid("index.html")
      //this.$store.commit("getId",localStorage.getItem("openid"))
      this.getOpenid("index.html")
      console.log(this.$store.state.host)
      console.log(this.$store.state.openId)
      this.getnewslist()
      this.getperinfo()
      this.getywlist()


    },
    methods:{
      // 获取业务
      getywlist(){
        this.$http.post(this.$store.state.host+"/interface/yewuList",{},{emulateJSON:true})
        .then(res=>{
          //发送成功
          console.log(res)
          if(res.body.code==0){
            this.ywlist=res.body.list
          }

          //if()
        },res=>{
           //发送失败
        })
      },
      // 业务跳转
      link(obj,type,title){
        if(this.SMstatus!=1){
          Dialog.alert({
            message: '您尚未实名认证，暂不能使用本功能，请前往个人中心进行实名认证',
          }).then(() => {
            this.$router.push("/Realinfo")
          });
        }
        else{
            this.$router.push({path:'/Ywlist',query:{ywId:obj,type:type,title:title}})
        }

      },
      // 获取个人信息
      getperinfo(){
        this.$http.post(this.$store.state.host+"/interface/getUser",{openid:this.$store.state.openId},{emulateJSON:true})
        .then(res=>{
          //发送成功
          console.log(res)
          if(res.body.code==0){
            this.SMstatus=res.body.userPd.status
          }

          //if()
        },res=>{
           //发送失败
        })
      },
      // 获取新闻列表
      getnewslist(){
        this.$http.post(this.$store.state.host+"/interface/newsList",{},{emulateJSON:true})
        .then(res=>{
          //发送成功
          if(res.body.code==0){
            this.newslist=res.body.list
            console.log(this.newslist)
          }

          //if()
        },res=>{
           //发送失败
        })
      },
      /* 时间截取*/
      str(obj){
        obj=obj.substring(0,10)
        return obj
      },
      // 视频点击
      videoplay(){
        var video=document.getElementById("vd0");
        if(video.paused == true){
          video.play()
        }
        else{
          video.pause();
        }

      }
    }
  };
</script>

<style lang="less" scoped>
.list{
  padding: .4rem .32rem 0rem;
  display: flex;
  flex-wrap: wrap;
  a{
    width: 25%;
    text-align: center;
    font-size: .24rem;
    margin-bottom: .4rem;
    img{
      width: .8rem;
      height: .8rem;
    }
    p{
      margin: 0px;
      color: #333333;
      margin-top: .12rem;
    }
  }
}
.line{
  width: 100%;
  height: .1rem;
  background: #fcfcfc;
}
.newslist{
  padding: .32rem;
  .title{
    font-size: .3rem;
    display: flex;
    justify-content: space-between;
    p{
      margin: 0px;
    }
    p::before{
      content: "";
      display: inline-block;
      width: .08rem;
      height: .24rem;
      background: #e78b6d;
      margin-right: .1rem;
    }
    a{
      color: #999999;
    }
  }
  .news{
    font-size: .3rem;
    .video{
      margin-top: .25rem;
      .van-swipe-item{
        margin-right: .2rem;
        position: relative;
        video{
          width: 100%;
          height: 150px;
              object-fit: fill;

        }
        img{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
          width:.72rem;
          z-index: 2;
        }
      }

    }
    a{
      display: flex;
      justify-content: space-between;
      color: #666666;
      padding-bottom: .25rem;
      border-bottom: .01rem solid #f4f3f3;
      margin-top: .25rem;
      p:nth-of-type(1){
        width: 65%;
      }
      p:nth-of-type(1)::before{
          content:"";
          display: inline-block;
          width: .1rem;
          height: .1rem;
          position: relative;
          bottom:.07rem;
          background: #e78b6d;
          margin-right: .14rem;
        }

    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/index.vue